import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Qué es ENFOCADO exactamente?',
  answer: 'ENFOCADO es un sistema visual de organización y ejecución que te ayuda a cumplir hábitos y decisiones sin depender de la motivación. Ves lo que tenés que hacer, cuándo hacerlo y si cumpliste o no.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: 'Es un producto 100% digital. Lo descargás al instante después de la compra y podés usarlo todas las veces que quieras.'
}, {
  question: '¿Cómo se usa el sistema?',
  answer: 'Podés usarlo de dos formas:\n\n• Impreso, escribiendo y marcando a mano\n• Digital, desde tablet, iPad o computadora (usando apps de notas o PDF)\n\nVos elegís la forma que más se adapte a tu estilo.'
}, {
  question: '¿Necesito experiencia previa en hábitos u organización?',
  answer: 'No. El sistema está pensado para personas que:\n\n• Se dispersan\n• Procrastinan\n• Se saturan mentalmente\n\nENFOCADO simplifica todo para que ejecutes sin pensar de más.'
}, {
  question: '¿Cuánto tiempo lleva por día?',
  answer: 'Muy poco. Entre 5 y 10 minutos diarios para planificar y marcar progreso. La idea es sacarte peso mental, no agregarte tareas.'
}, {
  question: '¿Cuándo recibo el acceso?',
  answer: 'Inmediatamente después del pago. Recibís el acceso por email y podés descargar el sistema en el momento.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <>
      <section className="py-16 md:py-24 bg-black" data-id="element-73">
        <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-74">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-12 uppercase tracking-tight" data-id="element-75">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-1" data-id="element-76">
            {faqs.map((faq, index) => <div key={index} className="border-b border-white/10" data-id="element-77">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center py-5 text-left focus:outline-none group" data-id="element-78">
                  <span className="font-medium text-white text-sm md:text-base pr-8" data-id="element-79">
                    {faq.question}
                  </span>
                  <ChevronDown className={`flex-shrink-0 text-gray-500 transition-transform duration-200 ${openIndex === index ? 'rotate-180 text-[#FF6B35]' : ''}`} size={20} data-id="element-80" />
                </button>

                <AnimatePresence data-id="element-81">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-82">
                      <div className="pb-5 text-gray-400 text-sm md:text-base leading-relaxed whitespace-pre-line" data-id="element-83">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>

      {/* Garantía Section */}
      <section className="py-12 md:py-16 bg-black border-t border-white/5" data-id="element-84">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center" data-id="element-85">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 uppercase tracking-tight" data-id="element-86">
            Garantía ENFOCADO – 7 Días Sin Riesgo
          </h2>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-xl mx-auto" data-id="element-87">
            Si después de usar el sistema sentís que no es para vos, te
            devolvemos el 100% de tu inversión. Sin preguntas, sin vueltas.
          </p>
        </div>
      </section>
    </>;
}